module.exports = __webpack_public_path__ + "img/home.c6ab3dbb.png";